define('Store.LiveOrder.Helper', [
    'LiveOrder.Model'
], function StoreLiveOrder(
    LiveOrderModel
) {
    return {
        isReadyToCheckout: function isReadyToCheckout() {
            return LiveOrderModel.getInstance().get('lines').all(function any(row) {
                return !!row.get('item').get('storePurchasable');
            });
        },

        hasPriceChanged: function hasPriceChanged() {
            var cart = LiveOrderModel.getInstance();
            var lines = cart.get('lines');
            var oldLines = cart.get('oldCart');
            return oldLines && oldLines.length && lines.any(function anyLine(line) {
                var oldLine = _.find(oldLines, function findLine(old) {
                    return line.get('item').get('internalid') + '' === old.item.internalid + '';
                });

                return oldLine && parseFloat(oldLine.rate, 10) !== parseFloat(line.get('rate'), 10);
            });
        },

        hasLinePriceChanged: function hasLinePriceChanged(line) {
            var cart = LiveOrderModel.getInstance();
            var oldLines = cart.get('oldCart');
            var oldLine = oldLines && oldLines.length && _.find(oldLines, function anyLine(old) {
                return old.item.internalid + '' === line.item.internalid + '';
            });

            return oldLine && parseFloat(oldLine.rate, 10) !== parseFloat(line.rate, 10);
        }
    };
});
